import React, { createContext, useState, useMemo, useCallback, useContext } from 'react';
import uniqueId from 'lodash/uniqueId';

type Props = {
  children: React.Node,
};

type ToastType = {
  type?: 'success' | 'danger' | 'info' | 'warning',
  id?: string,
  message: string,
  onClick?: () => void,
};

export const ToastContext = createContext();

const defaultValue = {
  type: 'info',
  message: '',
  additional: '',
  onClick: () => {},
};

export const ToastProvider = ({ children }: Props) => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback(({ id = uniqueId(), ...rest }: ToastType) => {
    setToasts(t => [...t, { ...defaultValue, id, ...rest }]);
  }, []);

  const removeToast = id => setToasts(t => t.filter(t => t.id !== id));
  const removeAllToasts = () => setToasts([]);

  const providerValue = useMemo(() => ({ addToast, removeToast, removeAllToasts, toasts }), [toasts]);

  return <ToastContext.Provider value={providerValue}>{children}</ToastContext.Provider>;
};

export const useToast = () => {
  return useContext(ToastContext);
};
